import React, { useEffect } from "react";
import PropTypes, { string } from "prop-types";
import classNames from "classnames";
import "./style.scss";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import AccordionWrapper from "../../elements/accordion-wrapper";
import CarDeliveryOptions from "../../sections/car-delivery-options";
import { useDispatch, useSelector } from "react-redux";
import { setCarBookingProgressAction } from "../../redux/actions/car-booking";
import { carBookingProgressSelector } from "../../selectors/car-booking";
import QAAccordionList from "../../sections/qa-accordion-list";
import { useHistory } from "react-router-dom";

const BookLocation = ({ fields, radioAccordion, setShowModal }) => {
  /*Redux Start*/
  const dispatch = useDispatch();
  const carBookingProgress = useSelector(carBookingProgressSelector);
  const setCarBookingProgress = payload => dispatch(setCarBookingProgressAction(payload));
  /*Redux End*/
  const { headingType, heading, body, qaItems, ctaChooseTime, label } = fields;
  const { link, colorScheme, iconName } = ctaChooseTime.fields || {};
  const { href, text } = link?.value || {};

  const history = useHistory();
  useEffect(() => {
    setCarBookingProgress({
      steps: [
        {
          label: "",
          done: true,
          active: false,
          route: "#",
          disabled: true
        },
        {
          label: "",
          done: true,
          active: true,
          route: "#",
          disabled: true
        }
      ]
    });
  }, carBookingProgress);
  const button = {
    buttonText: text,
    colorScheme,
    iconName,
    callback() {
      history.replace(href);
    }
  };
  return (
    <section className="test-drive-book">
      <Heading type={headingType} html={heading} className="heading" typographyClass={"type-h3"} />
      <BodyText html={body} />
      <CarDeliveryOptions {...{ ...radioAccordion, setShowModal, button }} />
      <QAAccordionList items={qaItems} />
    </section>
  );
};

// BookLocation.propTypes = {
//   heading: PropTypes.shape({
//     type: PropTypes.string,
//     html: PropTypes.string,
//     typographyClass: PropTypes.string
//   }),
//   bodyText: PropTypes.shape({
//     type: PropTypes.string,
//     html: PropTypes.string,
//     typographyClass: PropTypes.string
//   }),
//   items: PropTypes.shape({
//     items: PropTypes.array,
//     heading: PropTypes.shape({
//       type: PropTypes.string,
//       html: PropTypes.string,
//       typographyClass: PropTypes.string
//     }),
//     body: PropTypes.string,
//     collapsed: PropTypes.bool
//   }),
//   type: PropTypes.oneOf(["car_delivery", "test_drive"])
// };

export default BookLocation;
